import { Icon } from "@/components/ui/Icon";
import { cn } from "@/lib/cn";

interface LogoProps {
  className?: string;
  iconClassName?: string;
  textClassName?: string;
  showText?: boolean;
}

export const Logo = ({ className, iconClassName, textClassName, showText = true }: LogoProps) => (
  <div className={className}>
    <div className="flex items-center gap-2 p-2">
      <Icon
        name="logo"
        className={cn("size-6.5 text-neutral-50", iconClassName)}
      />
      {showText && (
        <span
          className={cn(
            "text-[1.5425rem] leading-normal font-medium tracking-[-0.04625rem] text-neutral-50",
            textClassName
          )}
        >
          Spider
        </span>
      )}
    </div>
  </div>
);
